import React from "react";
import Grid2 from '@mui/material/Unstable_Grid2';
import { Breadcrumb } from "../../components";
import { CardHeader } from "../../components/cards";
import { Item, Anchor, Box, Text } from "../../components/elements";
import PageLayout from "../../layouts/PageLayout";
import data from "../../data/blocks/colors.json";

export default function Colors() {
    return (
        <PageLayout>
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12 }}>
                    <Breadcrumb title={ data?.pageTitle }>
                        {data?.breadcrumb.map((item, index) => (
                            <Item key={ index } className="mc-breadcrumb-item">
                                {item.path ? <Anchor className="mc-breadcrumb-link" href={ item.path }>{ item.text }</Anchor> : item.text }
                            </Item>
                        ))}
                    </Breadcrumb>
                </Grid2>
                {data?.variants.map((item, index) => (
                    <Grid2 size={{ xs: 12 }} key={ index }>
                        <Box className="mc-card p-4">
                            <CardHeader title={ item.title } />
                            <Box className="mc-color-group">
                                {item.colors.map((color, serial) => (
                                    <Box key={ serial } className="mc-color">
                                        <Box style={{ background: color.code }}></Box>
                                        <Text as="span">
                                            <Text as="small">{ color.name }</Text>
                                            <Text as="small">{ color.code }</Text>
                                        </Text>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Grid2>
                ))}
            </Grid2>
        </PageLayout>
    )
}